/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthErrorClassification } from './PalAuthErrorClassification';
import {
    PalAuthErrorClassificationFromJSON,
    PalAuthErrorClassificationFromJSONTyped,
    PalAuthErrorClassificationToJSON,
} from './PalAuthErrorClassification';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
} from './PalAuthPlatformPayorForm';
import type { PalAuthSubmissionErrorType } from './PalAuthSubmissionErrorType';
import {
    PalAuthSubmissionErrorTypeFromJSON,
    PalAuthSubmissionErrorTypeFromJSONTyped,
    PalAuthSubmissionErrorTypeToJSON,
} from './PalAuthSubmissionErrorType';
import type { PalAuthSubmissionGeneratedDocument } from './PalAuthSubmissionGeneratedDocument';
import {
    PalAuthSubmissionGeneratedDocumentFromJSON,
    PalAuthSubmissionGeneratedDocumentFromJSONTyped,
    PalAuthSubmissionGeneratedDocumentToJSON,
} from './PalAuthSubmissionGeneratedDocument';
import type { PalAuthSubmissionLead } from './PalAuthSubmissionLead';
import {
    PalAuthSubmissionLeadFromJSON,
    PalAuthSubmissionLeadFromJSONTyped,
    PalAuthSubmissionLeadToJSON,
} from './PalAuthSubmissionLead';
import type { PalAuthSubmissionMetadata } from './PalAuthSubmissionMetadata';
import {
    PalAuthSubmissionMetadataFromJSON,
    PalAuthSubmissionMetadataFromJSONTyped,
    PalAuthSubmissionMetadataToJSON,
} from './PalAuthSubmissionMetadata';
import type { PalAuthSubmissionMode } from './PalAuthSubmissionMode';
import {
    PalAuthSubmissionModeFromJSON,
    PalAuthSubmissionModeFromJSONTyped,
    PalAuthSubmissionModeToJSON,
} from './PalAuthSubmissionMode';
import type { PalAuthSubmissionRemotePatientSearchConfig } from './PalAuthSubmissionRemotePatientSearchConfig';
import {
    PalAuthSubmissionRemotePatientSearchConfigFromJSON,
    PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped,
    PalAuthSubmissionRemotePatientSearchConfigToJSON,
} from './PalAuthSubmissionRemotePatientSearchConfig';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
} from './PalAuthSubmissionStatus';
import type { PalAuthSubmissionStatusInfo } from './PalAuthSubmissionStatusInfo';
import {
    PalAuthSubmissionStatusInfoFromJSON,
    PalAuthSubmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionStatusInfoToJSON,
} from './PalAuthSubmissionStatusInfo';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalDocumentToSubmit } from './PalDocumentToSubmit';
import {
    PalDocumentToSubmitFromJSON,
    PalDocumentToSubmitFromJSONTyped,
    PalDocumentToSubmitToJSON,
} from './PalDocumentToSubmit';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
} from './PalReauthCaseManager';
import type { PalReauthSubmissionListEntry } from './PalReauthSubmissionListEntry';
import {
    PalReauthSubmissionListEntryFromJSON,
    PalReauthSubmissionListEntryFromJSONTyped,
    PalReauthSubmissionListEntryToJSON,
} from './PalReauthSubmissionListEntry';
import type { TimExecution } from './TimExecution';
import {
    TimExecutionFromJSON,
    TimExecutionFromJSONTyped,
    TimExecutionToJSON,
} from './TimExecution';

/**
 * 
 * @export
 * @interface PalAuthSubmission
 */
export interface PalAuthSubmission {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    tim_execution_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    form_id?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PalAuthSubmission
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     * @type {PalAuthSubmissionStatus}
     * @memberof PalAuthSubmission
     */
    status?: PalAuthSubmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    submitted_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    submitted_by_user_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    is_non_submission_flow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    is_oon?: boolean;
    /**
     * 
     * @type {PalAuthSubmissionMode}
     * @memberof PalAuthSubmission
     */
    submission_mode?: PalAuthSubmissionMode;
    /**
     * 
     * @type {PalAuthPlatformPayorForm}
     * @memberof PalAuthSubmission
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    document_extraction_status?: PalAuthSubmissionDocumentExtractionStatusEnum;
    /**
     * 
     * @type {Array<PalDocumentToSubmit>}
     * @memberof PalAuthSubmission
     */
    documents_to_submit?: Array<PalDocumentToSubmit>;
    /**
     * Signed S3 URL for the submission document
     * @type {string}
     * @memberof PalAuthSubmission
     */
    submission_document_s3_url?: string;
    /**
     * 
     * @type {PalAuthSubmissionStatusInfo}
     * @memberof PalAuthSubmission
     */
    status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     * @type {PalAuthSubmissionStatusInfo}
     * @memberof PalAuthSubmission
     */
    previous_status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    status_updated_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    should_sync_remote_status?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    external_id?: string;
    /**
     * Normalized destination fax number used for eFax submissions.
     * @type {string}
     * @memberof PalAuthSubmission
     */
    destination_fax_number?: string;
    /**
     * Normalized fax number the eFax was sent from. Null when sent from the shared/generic exacare fax number rather than a dedicated eFax inbox number.
     * @type {string}
     * @memberof PalAuthSubmission
     */
    sender_fax_number?: string;
    /**
     * 
     * @type {TimExecution}
     * @memberof PalAuthSubmission
     */
    tim_execution?: TimExecution;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUser}
     * @memberof PalAuthSubmission
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    can_revert_status?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    can_restart?: boolean;
    /**
     * 
     * @type {PalAuthSubmissionErrorType}
     * @memberof PalAuthSubmission
     */
    error_type?: PalAuthSubmissionErrorType;
    /**
     * 
     * @type {PalAuthErrorClassification}
     * @memberof PalAuthSubmission
     */
    error_classification?: PalAuthErrorClassification;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    is_syncing_remote_status?: boolean;
    /**
     * 
     * @type {PalAuthSubmissionMetadata}
     * @memberof PalAuthSubmission
     */
    metadata?: PalAuthSubmissionMetadata;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmission
     */
    error_details?: string;
    /**
     * ISO timestamp of when the submission document PDF was generated
     * @type {string}
     * @memberof PalAuthSubmission
     */
    submission_document_generated_at?: string;
    /**
     * ISO timestamp of when the document extraction completed
     * @type {string}
     * @memberof PalAuthSubmission
     */
    document_extraction_completed_at?: string;
    /**
     * 
     * @type {PalAuthSubmissionRemotePatientSearchConfig}
     * @memberof PalAuthSubmission
     */
    remote_patient_search_config?: PalAuthSubmissionRemotePatientSearchConfig;
    /**
     * 
     * @type {PalAuthSubmissionGeneratedDocument}
     * @memberof PalAuthSubmission
     */
    generated_document?: PalAuthSubmissionGeneratedDocument;
    /**
     * 
     * @type {PalAuthSubmissionLead}
     * @memberof PalAuthSubmission
     */
    lead?: PalAuthSubmissionLead;
    /**
     * Whether the submission already has re-auth cycles associated to it
     * @type {boolean}
     * @memberof PalAuthSubmission
     */
    has_reauths?: boolean;
    /**
     * ID of the case manager associated with this pre-auth. Provide on update to assign (null clears it).
     * @type {string}
     * @memberof PalAuthSubmission
     */
    case_manager_id?: string | null;
    /**
     * 
     * @type {PalReauthCaseManager}
     * @memberof PalAuthSubmission
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     * @type {PalReauthSubmissionListEntry}
     * @memberof PalAuthSubmission
     */
    latest_pal_reauth?: PalReauthSubmissionListEntry;
}


/**
 * @export
 */
export const PalAuthSubmissionDocumentExtractionStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed'
} as const;
export type PalAuthSubmissionDocumentExtractionStatusEnum = typeof PalAuthSubmissionDocumentExtractionStatusEnum[keyof typeof PalAuthSubmissionDocumentExtractionStatusEnum];


/**
 * Check if a given object implements the PalAuthSubmission interface.
 */
export function instanceOfPalAuthSubmission(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionFromJSON(json: any): PalAuthSubmission {
    return PalAuthSubmissionFromJSONTyped(json, false);
}

export function PalAuthSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tim_execution_id': !exists(json, 'tim_execution_id') ? undefined : json['tim_execution_id'],
        'form_id': !exists(json, 'form_id') ? undefined : json['form_id'],
        'submission_form_data': !exists(json, 'submission_form_data') ? undefined : json['submission_form_data'],
        'status': !exists(json, 'status') ? undefined : PalAuthSubmissionStatusFromJSON(json['status']),
        'submitted_at': !exists(json, 'submitted_at') ? undefined : json['submitted_at'],
        'submitted_by_user_id': !exists(json, 'submitted_by_user_id') ? undefined : json['submitted_by_user_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
        'is_oon': !exists(json, 'is_oon') ? undefined : json['is_oon'],
        'submission_mode': !exists(json, 'submission_mode') ? undefined : PalAuthSubmissionModeFromJSON(json['submission_mode']),
        'auth_platform_form': !exists(json, 'auth_platform_form') ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'document_extraction_status': !exists(json, 'document_extraction_status') ? undefined : json['document_extraction_status'],
        'documents_to_submit': !exists(json, 'documents_to_submit') ? undefined : ((json['documents_to_submit'] as Array<any>).map(PalDocumentToSubmitFromJSON)),
        'submission_document_s3_url': !exists(json, 'submission_document_s3_url') ? undefined : json['submission_document_s3_url'],
        'status_info': !exists(json, 'status_info') ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': !exists(json, 'previous_status_info') ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'status_updated_at': !exists(json, 'status_updated_at') ? undefined : json['status_updated_at'],
        'should_sync_remote_status': !exists(json, 'should_sync_remote_status') ? undefined : json['should_sync_remote_status'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'destination_fax_number': !exists(json, 'destination_fax_number') ? undefined : json['destination_fax_number'],
        'sender_fax_number': !exists(json, 'sender_fax_number') ? undefined : json['sender_fax_number'],
        'tim_execution': !exists(json, 'tim_execution') ? undefined : TimExecutionFromJSON(json['tim_execution']),
        'status_updated_by_user': !exists(json, 'status_updated_by_user') ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'can_revert_status': !exists(json, 'can_revert_status') ? undefined : json['can_revert_status'],
        'can_restart': !exists(json, 'can_restart') ? undefined : json['can_restart'],
        'error_type': !exists(json, 'error_type') ? undefined : PalAuthSubmissionErrorTypeFromJSON(json['error_type']),
        'error_classification': !exists(json, 'error_classification') ? undefined : PalAuthErrorClassificationFromJSON(json['error_classification']),
        'is_syncing_remote_status': !exists(json, 'is_syncing_remote_status') ? undefined : json['is_syncing_remote_status'],
        'metadata': !exists(json, 'metadata') ? undefined : PalAuthSubmissionMetadataFromJSON(json['metadata']),
        'error_details': !exists(json, 'error_details') ? undefined : json['error_details'],
        'submission_document_generated_at': !exists(json, 'submission_document_generated_at') ? undefined : json['submission_document_generated_at'],
        'document_extraction_completed_at': !exists(json, 'document_extraction_completed_at') ? undefined : json['document_extraction_completed_at'],
        'remote_patient_search_config': !exists(json, 'remote_patient_search_config') ? undefined : PalAuthSubmissionRemotePatientSearchConfigFromJSON(json['remote_patient_search_config']),
        'generated_document': !exists(json, 'generated_document') ? undefined : PalAuthSubmissionGeneratedDocumentFromJSON(json['generated_document']),
        'lead': !exists(json, 'lead') ? undefined : PalAuthSubmissionLeadFromJSON(json['lead']),
        'has_reauths': !exists(json, 'has_reauths') ? undefined : json['has_reauths'],
        'case_manager_id': !exists(json, 'case_manager_id') ? undefined : json['case_manager_id'],
        'case_manager': !exists(json, 'case_manager') ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'latest_pal_reauth': !exists(json, 'latest_pal_reauth') ? undefined : PalReauthSubmissionListEntryFromJSON(json['latest_pal_reauth']),
    };
}

export function PalAuthSubmissionToJSON(value?: PalAuthSubmission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tim_execution_id': value.tim_execution_id,
        'form_id': value.form_id,
        'submission_form_data': value.submission_form_data,
        'status': PalAuthSubmissionStatusToJSON(value.status),
        'submitted_at': value.submitted_at,
        'submitted_by_user_id': value.submitted_by_user_id,
        'is_non_submission_flow': value.is_non_submission_flow,
        'is_oon': value.is_oon,
        'submission_mode': PalAuthSubmissionModeToJSON(value.submission_mode),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value.auth_platform_form),
        'document_extraction_status': value.document_extraction_status,
        'documents_to_submit': value.documents_to_submit === undefined ? undefined : ((value.documents_to_submit as Array<any>).map(PalDocumentToSubmitToJSON)),
        'submission_document_s3_url': value.submission_document_s3_url,
        'status_info': PalAuthSubmissionStatusInfoToJSON(value.status_info),
        'previous_status_info': PalAuthSubmissionStatusInfoToJSON(value.previous_status_info),
        'status_updated_at': value.status_updated_at,
        'should_sync_remote_status': value.should_sync_remote_status,
        'external_id': value.external_id,
        'destination_fax_number': value.destination_fax_number,
        'sender_fax_number': value.sender_fax_number,
        'tim_execution': TimExecutionToJSON(value.tim_execution),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value.status_updated_by_user),
        'can_revert_status': value.can_revert_status,
        'can_restart': value.can_restart,
        'error_type': PalAuthSubmissionErrorTypeToJSON(value.error_type),
        'error_classification': PalAuthErrorClassificationToJSON(value.error_classification),
        'is_syncing_remote_status': value.is_syncing_remote_status,
        'metadata': PalAuthSubmissionMetadataToJSON(value.metadata),
        'error_details': value.error_details,
        'submission_document_generated_at': value.submission_document_generated_at,
        'document_extraction_completed_at': value.document_extraction_completed_at,
        'remote_patient_search_config': PalAuthSubmissionRemotePatientSearchConfigToJSON(value.remote_patient_search_config),
        'generated_document': PalAuthSubmissionGeneratedDocumentToJSON(value.generated_document),
        'lead': PalAuthSubmissionLeadToJSON(value.lead),
        'has_reauths': value.has_reauths,
        'case_manager_id': value.case_manager_id,
        'case_manager': PalReauthCaseManagerToJSON(value.case_manager),
        'latest_pal_reauth': PalReauthSubmissionListEntryToJSON(value.latest_pal_reauth),
    };
}

